import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Auto-oppdaterer service worker så snart en ny versjon er tilgjengelig.
 * Sikrer at brukere som åpner appen via en delingslenke (Messenger, FB osv.)
 * ikke ender på en cached, gammel HTML-versjon.
 */
export function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered');
      if (r) {
        const checkForUpdate = () => r.update().catch(() => {});
        window.addEventListener('focus', checkForUpdate);
      }
    },
    onRegisterError(error) {
      console.log('SW registration error', error);
    },
  });

  useEffect(() => {
    if (needRefresh) {
      updateServiceWorker(true);
    }
  }, [needRefresh, updateServiceWorker]);

  return null;
}
